import React, { useState } from "react";
import { PropertyCard, RoundCard, RunnerUpHeader } from "../../ui";
import Button from "../../library/components/Button";
import TextAreaField from "../../library/components/textarea";
import {
  useGetRejectByIdQuery,
  useUserUpdateMutation,
} from "../../services/nullificationservice";
import { useLocation, useNavigate } from "react-router";
import {
  TRY_AFTER_SOME_TIME,
  FILED_IS_REQUIRED,
} from "../../constants/constants";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
} from "../../constants/constants";
import { useDispatch } from "react-redux";
import { createAlert } from "../../features/alert/alerts";
import { Validators } from "../../library/utilities/Validator";
import "./index.css";
import CustomModal from "../../library/components/Modal/modal";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";

const Rejectnullification = ({constNameNoAndState,onRejectRequest}) => {
  const location = useLocation();
  const NullificationdataById = useGetRejectByIdQuery(location.state);
  const [UserUpdate, responseInfo] = useUserUpdateMutation();
  const [data, setData] = useState([]);
  const [errorValue, setErrorValue] = useState({});
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [remove, setRemove] = useState(false);
  const [responseData, setresponseData] = useState("");
  const [showConfirmationPopup, setConfirmationPopup] = useState(false);

  const propertyCardData = [
    // { key: "State", value: (getStateList?.filter((item)=>{
    //   return item?.stateCd===stateCd
    //     }))?.[0].stateName },
    { key: "State", value: constNameNoAndState.stateName  },
    {
      key: "Election Type",
      value: NullificationdataById?.data?.payload?.electionType,
    },
    {
      key: "Constituency Type",
      value: NullificationdataById?.data?.payload?.constType,
    },
    {
      key: "Constituency No. & Name",
      value: `${constNameNoAndState.constNo} - ${constNameNoAndState.constName}`,
    },
  ];

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getErrorValue = (key, value) => {
    setErrorValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const onClose = () => {
    setConfirmationPopup(false);
    setresponseData("");
  };

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  const onUpdate =  () => {
    let error = {};
    if (!data.remarks || data.remarks === "") {
      error["remarks"] = "This field is required";
    }
    if (Object.keys(error).length) {
      setErrorValue(error);
      setConfirmationPopup(false);
      return;
    }
    UserUpdate({
      id: location.state,
      approveRejectComment: data.remarks,
    }).then((res)=>{
      onSuccess(res?.data?.message);
      setConfirmationPopup(false);
      onRejectRequest()
    });
  };

  return (
    <>
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to Reject?"}
          children={
            <ConfirmationModal
              noOption={onClose}
              yesOption={onUpdate}
            />
          }
        />
      }
      <div className="after-approve col-md-12">
        <div className="container box shadow ">
          <RunnerUpHeaderNew title={"Enter Remarks to reject"} />
          <p>Are you sure you want to Reject?</p>
          <PropertyCard data={propertyCardData} />
          <p className="mt-2">Please enter remarks to Reject.</p>
          {}
          <TextAreaField
            type="textrea"
            inputClass="remarks_textarea"
            name="remarks"
            placeholder="Enter Remark"
            rows="4"
            cols="40"
            value={data.remarks}
            onChange={(val) => handleChange("remarks", val)}
            getError={(value) => getErrorValue("remarks", value)}
            validators={[
              {
                check: Validators.required,
                message: FILED_IS_REQUIRED,
              },
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getErrorValue={(val) => getErrorValue("remarks", val)}
            Error={errorValue}
          ></TextAreaField>
          <Button
            value="Reject"
            btnClass="verify-btn"
            onClick={() => setConfirmationPopup(true)}
          />
        </div>
      </div>
    </>
  );
};

export default Rejectnullification;
